/* eslint-disable @typescript-eslint/no-explicit-any */
export function buildFormData(
  formData: FormData,
  obj: any,
  parentKey = ''
): void {
  if (Array.isArray(obj)) {
    obj.forEach((element, index) => {
      buildFormData(formData, element, `${parentKey}[${index}]`);
    });
  } else if (typeof obj === 'object' && !(obj instanceof File)) {
    Object.keys(obj).forEach((key) => {
      buildFormData(formData, obj[key], parentKey ? `${parentKey}${key}` : key);
    });
  } else {
    const value =
      typeof obj === 'number' || typeof obj === 'boolean'
        ? obj.toString()
        : obj;
    formData.append(parentKey, value);
  }
}
